
    import {
        IonButtons,
        IonButton,
        IonContent,
        IonHeader,
        IonMenuButton,
        IonPage,
        IonTitle,
        IonToolbar,
        IonSegment,
        IonSegmentButton,
        IonLabel,
        alertController,

    } from '@ionic/vue';
    import {
        defineComponent
    } from 'vue';
    import DataTable from 'primevue/datatable';
    import Column from 'primevue/column';
    import Dropdown from 'primevue/dropdown';
    import Accordion from 'primevue/accordion';
    import AccordionTab from 'primevue/accordiontab';
    import AllShip from './MyAllShip.vue';
    import {
        ellipsisVertical,
        ellipsisVerticalOutline,
    } from "ionicons/icons";
    import PendingShipLog from './PendingShipLog.vue';

    export default defineComponent({
        name: 'My Device',
        components: {
            IonButtons,
            // IonButton,
            IonContent,
            IonHeader,
            IonMenuButton,
            IonPage,
            IonTitle,
            IonToolbar,
            IonSegment,
            IonSegmentButton,
            IonLabel,
            AllShip,
            PendingShipLog,
        },
        data() {
            return {
                segment:this.$route.params.segment?this.$route.params.segment:'Pending',
            }
        },
        methods:{
            segmentChanged(ev: CustomEvent) {
                this.segment = ev.detail.value;
                this.$router.push(`/my-ship-pricing-log/${ev.detail.value}`);
            }
        }
        
    });
